import { useState } from "react";
import { faqItems } from "@/mocks/films";

const tips = [
  { icon: "ri-compass-3-line", text: "先确定一个最打动你的母题，再顺着它找作品" },
  { icon: "ri-global-line", text: "同一母题在不同国家，会呈现完全不同的处理方式" },
  { icon: "ri-bookmark-3-line", text: "把感兴趣的作品记录下来，按地区建立自己的片单" },
];

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqItems[0]?.id ?? null);

  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50 border-t border-background-200">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-[0.8fr_1.2fr] gap-8 lg:gap-14">
        <div className="lg:sticky lg:top-24 self-start">
          <span className="text-xs md:text-sm font-label tracking-[0.3em] text-primary-600 uppercase">FAQ</span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">常见问答</h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
            关于「伦理电影」的界定、各地风格差异以及如何入手，这里整理了几个最常被问到的问题。
          </p>

          <div className="mt-7 space-y-3">
            {tips.map((tip) => (
              <div key={tip.text} className="flex items-start gap-3 p-3.5 rounded-lg bg-background-100 border border-background-200">
                <span className="w-8 h-8 shrink-0 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${tip.icon} text-base`} aria-hidden="true"></i>
                </span>
                <p className="text-sm leading-relaxed text-foreground-700">{tip.text}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className={`rounded-lg border transition-colors ${
                  isOpen ? "border-primary-300 bg-primary-50" : "border-background-200 bg-background-100"
                }`}
              >
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenId(isOpen ? null : item.id)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center justify-between gap-4 text-left px-5 py-4 cursor-pointer"
                  >
                    <span className="font-heading text-base md:text-lg font-semibold text-foreground-950">{item.question}</span>
                    <i
                      className={`shrink-0 text-lg text-primary-600 transition-transform duration-300 ${
                        isOpen ? "ri-subtract-line rotate-180" : "ri-add-line"
                      }`}
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    isOpen ? "max-h-[320px] opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <p className="px-5 pb-5 text-sm md:text-base leading-relaxed text-foreground-700">{item.answer}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}